import {Component, OnInit, ViewChild, Inject} from '@angular/core';
import {SurveyModel} from '../../../../shared/models/survey/survey.model';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {ResponseSnackbarService} from '../../../../shared/services/response-snackbar.service';
import {MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {MatCalendar} from '@angular/material/datepicker';
import {Util} from '../../../../shared/utils/Util';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-survey-date-setter',
  templateUrl: './survey-date-setter.component.html',
  styleUrls: ['./survey-date-setter.component.scss']
})
export class SurveyDateSetterComponent implements OnInit {
  loading: boolean;
  surveyId: number;
  surveyDate: any;
  oppositeDate: Date;
  selected: Date | null;
  allDatesEmpty: boolean;

  @ViewChild(MatCalendar, {static: false}) calendar: MatCalendar<any>;

  constructor(
    private restService: RestService,
    private dialogRef: MatDialogRef<SurveyDateSetterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private responseSnackbarService: ResponseSnackbarService
  ) {
    this.surveyId = data?.surveyId;
    this.surveyDate = data?.surveyDate;
    this.allDatesEmpty = data?.allDatesEmpty || false;
  }

  ngOnInit(): void {
    this.selected = this.oppositeDate;
  }

  onChangeSurveyDate(){
    this.loading = true;
    if (this.selected == null) {
      this.loading = false;
      this.responseSnackbarService.onResponseMessage('Please select a date', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return;
    }
    const selectedDate = this.datePipe.transform(
      Util.addCurrentTimeToDate(this.selected),
      GeneralConstant.JPA_DATE_FORMAT
    );
    const isLscDate = this.surveyDate === 'lscStartDate' || this.surveyDate === 'lscEndDate';
    const mainPayload: any = {
      surveyId: this.surveyId,
      checkDate: isLscDate ? (this.surveyDate === 'lscStartDate' ? 'startDate' : 'endDate') : this.surveyDate,
      date: selectedDate
    };
    if (isLscDate) {
      mainPayload.isLsc = true;
    }
    const shouldAlsoSetEndDate = (this.surveyDate === 'startDate' && this.allDatesEmpty) || this.surveyDate === 'lscStartDate';
    if (shouldAlsoSetEndDate) {
      const startDateRequest$ = this.restService.request<SurveyModel>(
        RequestMethod.PUT,
        ApiEndpoints.SURVEY.SURVEY,
        Actions.SURVEY.SET_DATE,
        {body: mainPayload}
      ).pipe(take(1));
      startDateRequest$.subscribe(
        startRes => {
          const endDatePayload: any = {
            surveyId: this.surveyId,
            checkDate: 'endDate',
            date: selectedDate
          };
          if (isLscDate) {
            endDatePayload.isLsc = true;
          }
          this.restService.request<SurveyModel>(
            RequestMethod.PUT,
            ApiEndpoints.SURVEY.SURVEY,
            Actions.SURVEY.SET_DATE,
            {body: endDatePayload}
          ).pipe(take(1)).subscribe(
            endRes => {
              this.loading = false;
              this.responseSnackbarService.onResponse(startRes);
              this.dialogRef.close({
                success: startRes.success && endRes.success,
                date: this.selected,
                field: this.surveyDate
              });
            },
            err => {
              this.loading = false;
              this.responseSnackbarService.onResponseMessage(
                'Something went wrong while setting end date.',
                GeneralConstant.SNACKBAR_RES_ERROR_CLASS
              );
            }
          );
        },
        err => {
          this.loading = false;
          this.responseSnackbarService.onResponseMessage(
            'Something went wrong while setting start date.',
            GeneralConstant.SNACKBAR_RES_ERROR_CLASS
          );
        }
      );
    } else {
      this.restService.request<SurveyModel>(
        RequestMethod.PUT,
        ApiEndpoints.SURVEY.SURVEY,
        Actions.SURVEY.SET_DATE,
        {body: mainPayload}
      ).pipe(take(1)).subscribe(
        response => {
          this.loading = false;
          this.responseSnackbarService.onResponse(response);
          this.dialogRef.close({
            success: response.success,
            date: this.selected,
            field: this.surveyDate
          });
        });
    }
  }

  onTodayDate() {
    this.calendar.activeDate = new Date();
    this.selected = new Date();
  }

  surveyDateLabels: { [key: string]: string } = {
    surveyReportReceived: 'Survey Report Received Date',
    notificationLetterSent: 'Survey Report Sent Date',
    correctionsDue: 'Corrections Due Date',
    correctionsCompleted: 'Corrections Completed Date',
    pocDue: 'POC Due Date',
    pocReceived: 'POC Received Date',
    pocAccepted: 'POC Accepted Date',
  };

  get title(): string {
    return this.surveyDateLabels[this.data?.surveyDate];
  }
}
